export const AUTHORITY_BUCKETS = [
  "MFN",
  "122",
  "201",
  "232",
  "301",
  "IEEPA",
  "Ch99",
  "MTB",
] as const;

export type TariffAnalysisAuthority = (typeof AUTHORITY_BUCKETS)[number];
export type FindingSign = "savings" | "risk";

export type TariffAnalysisAggregationRow = {
  entrySummaryNumber?: string;
  entrySummaryLineNumber?: number;
  htsNumberFull?: string;
  htsDescription?: string;
  countryOfOriginCode?: string;
  manufacturerID?: string;
  manufacturerName?: string;
  goodsValue?: number;
  aceDuty: number;
  correctDuty: number;
  difference: number;
  finding: string;
  ch99?: string;
  ch99Code?: string;
  ch99Code2?: string;
  ch99CodeList?: string[];
  ch99Details?: { code: string; description: string; rate: number }[];
  ch99Exclusions?: unknown[];
  expectedBreakdown?: { authority: string; rate: number; ch99Codes?: string[] }[];
  discrepancyAuthorities?: string[];
  authorityBreakdown?: {
    authority: string;
    expectedAmount: number;
    aceAmount: number;
    difference: number;
    codes?: string[];
  }[];
  ch99DutyDict?: Record<string, number>;
  isMetalSplitBundle?: boolean;
};
